document.addEventListener( 'DOMContentLoaded', () => {

	const instagramFeed = document.getElementById( 'sb_instagram' )
	if ( ! instagramFeed ) { return false }

	const mainPhoto = document.querySelector( '.sbi_photo' )
	const photoItem = document.querySelector( '.sbi_item' )
	let date = photoItem.getAttribute( 'data-date' )
	const caption = mainPhoto.querySelector( 'img' ).alt
	const captionHeader = document.createElement( 'div' )
	const headerHolder = document.createElement( 'div' )
	headerHolder.setAttribute( 'data-header-text', '' )
	headerHolder.classList.add( 'flex', 'items-center', 'mb3', 'mb4-ns', 'f6', 'f5-ns' )
	captionHeader.setAttribute( 'data-caption-header', '' )
	captionHeader.classList.add( 'pl3', 'pr0-ns' )
	const profileHeader = document.createElement( 'h3' )
	profileHeader.innerText = 'This is PNH'
	const captionHolder = document.createElement( 'p' )
	const dateHolder = document.createElement( 'p' )
	captionHolder.classList.add( 'mb0' )
	captionHolder.style.maxHeight = '13rem'
	captionHolder.style.overflow = 'auto'
	// var timestamp = 1301090400,
	date = new Date( date * 1000 )
	const monthsArray = [
		'January',
		'February',
		'March',
		'April',
		'May',
		'June',
		'July',
		'August',
		'September',
		'October',
		'November',
		'December'
	]

	date = `${monthsArray[ date.getMonth() ]} ${date.getDate()}, ${ date.getFullYear() }`
	dateHolder.innerText = date
	dateHolder.classList.add( 'mb0' )
	captionHolder.innerText = caption
	const instagramData = document.querySelector( '[data-metadata-content]' )
	instagramData.classList.add( 'mw-100', 'f6', 'f5-ns' )
	instagramData.appendChild( headerHolder )
	const headerImage = document.createElement( 'img' )
	headerImage.alt = 'This Is PNH logo.'
	headerImage.classList.add( 'pr3-ns', 'mw2', 'mw3-ns' )
	headerImage.src = '/wp-content/uploads/2020/06/apple-icon-touch.png'
	headerHolder.appendChild( headerImage )
	headerHolder.appendChild( captionHeader )
	captionHeader.appendChild( profileHeader )
	captionHeader.appendChild( dateHolder )
	instagramData.appendChild( captionHolder )
} )
